import React, { useEffect, useRef, useState } from "react";
import { SESSION_RELOGIN_EVENT } from "../utils/sessionReloginModal";
import { SESSION_LOGGED_IN_ELSEWHERE_MESSAGE } from "../utils/auth";

/**
 * Global modal (login / OTP popup style) when session token is invalid elsewhere.
 * Redirect runs only after the user clicks OK (see clearAuthWithReloginNotice).
 */
export default function SessionReloginModalGate() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(SESSION_LOGGED_IN_ELSEWHERE_MESSAGE);
  const onAckRef = useRef(null);

  useEffect(() => {
    const onRequest = (e) => {
      const detail = e?.detail || {};
      setMessage(
        typeof detail.message === "string" && detail.message.trim()
          ? detail.message.trim()
          : SESSION_LOGGED_IN_ELSEWHERE_MESSAGE
      );
      onAckRef.current = typeof detail.onAck === "function" ? detail.onAck : null;
      setOpen(true);
    };
    window.addEventListener(SESSION_RELOGIN_EVENT, onRequest);
    return () => window.removeEventListener(SESSION_RELOGIN_EVENT, onRequest);
  }, []);

  const handleOk = () => {
    setOpen(false);
    const ack = onAckRef.current;
    onAckRef.current = null;
    ack?.();
  };

  if (!open) return null;

  return (
    <div
      className="small-popup-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-relogin-title"
    >
      <div className="small-modal min-w-[350px] !max-w-[90vw] !rounded-3xl px-6 pb-6 pt-4">
        <div className="mx-auto mt-2 flex h-[100px] w-[100px] items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-[88px] w-[88px]"
            viewBox="0 0 24 24"
            aria-hidden
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              fill="none"
              stroke="#dc2626"
              strokeWidth="1.5"
              opacity="0.35"
            />
            <circle cx="12" cy="12" r="10" fill="#fef2f2" stroke="#dc2626" strokeWidth="1.5" />
            <path
              d="M8 8l8 8M16 8l-8 8"
              stroke="#dc2626"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h2
          id="session-relogin-title"
          className="text-center text-[22px] font-semibold text-black/80 md:text-[26px]"
        >
          Session ended
        </h2>
        <p className="mt-3 text-center text-[14px] font-Montserratmedium leading-relaxed text-[#131313]/75">
          {message}
        </p>
        <button
          type="button"
          onClick={handleOk}
          className="mt-6 mb-1 min-w-[140px] rounded px-4 py-2.5 bg-[#a4b792] text-sm font-semibold text-white hover:bg-[#8fa37d]"
        >
          OK
        </button>
      </div>
    </div>
  );
}
